<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 0">
               <base-button slot="title" type="success" class="dropdown-toggle">
                 POS Profiles - {{_.startCase(currentProfile)}}
               </base-button> 
               <a v-for="profile in activeModules" :key="profile.id" @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)" class="dropdown-item" href="#">{{profile.name}}</a>
            </base-dropdown>
            <base-dropdown v-else>
               <base-button slot="title" type="primary" class="dropdown-toggle">
                 POS Profiles
               </base-button> 
               <a class="dropdown-item" disabled>No active module/s under this feature</a>
               <!-- <a v-for="profile in activeModules" :key="profile.id" @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)))" class="dropdown-item" href="#">{{profile.name}}</a> -->
            </base-dropdown>
        </base-header>

         <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card mb-3">
                        <div class="row no-gutters">
                            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                              <div class="card-body">
                                  <filter-bar @changeFilter="changeFilter"></filter-bar>
                              </div>
                            </div>

                            <div class="col-md-9">
                              <div class="card-body">
                                  <terminals-table v-if="currentProfile == 'terminals' || currentProfile == 'terminal_templates'" status="filterStatus" :key="componentKey" :accessRights="accessRights"></terminals-table>
                                  <profiles-table v-else :status="filterStatus" :key="formKey" :accessRights="accessRights"></profiles-table>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
  import HTTPRequest from '../../controllers/httpRequest.js'
  import TerminalsTable from '../Tables/TerminalsTable.vue'
  import ProfilesTable from '../Tables/PosProfilesTable.vue'
  import FilterBar from './../FilterBar' 
  import secureStorage from '../../controllers/secureStorage';
  
  import { mapState, mapActions } from 'vuex'

  export default {
      data: function(){
          return {
              filterStatus: "",
              componentKey: 0,
              formKey: 0,
              activeModules: [],
              accessRights: [],
          }
      },
      mounted: async function() {
            var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=P-001', null, null)
            this.activeModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
            if( this.activeModules.length > 0 ){
                var profile = _.snakeCase(this.activeModules[0].name)
                this.setCurrentProfile(_.pluralize(profile), this.activeModules[0].id);
                // this.formKey++
            } else {
                this.setCurrentProfile(null, null);
                // this.formKey++
            } 
      },
      computed: {
              ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
          },
          components: {
              ProfilesTable,
              TerminalsTable,
              FilterBar
          },
          methods: {
              ...mapActions(['updateCurrentProfile', 'updateParameters']),
            //   setCurrentProfile(profile) {
            //       this.componentKey++
            //       this.updateCurrentProfile(profile)
            //   },
            async setCurrentProfile(profile, id){
                if(profile == "salesmans")
                    profile = "salesmen"

                this.profileId = id
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[id]
                }else {
                    this.accessRights = []
                }
                this.updateCurrentProfile(profile)
                this.componentKey++;
                this.formKey++;
                // alert(this.accessRights.toString())
            },
              changeFilter(statusFilter, searchFilter, searchText) {
                  this.filterStatus = statusFilter
                  if(statusFilter == "0"){
                      this.updateParameters("?" + searchFilter + "=" + searchText)
                  } else if (statusFilter == "A") {
                      this.updateParameters("?" + searchFilter + "=" + searchText + "&status=A")
                  } else {
                      this.updateParameters("?" + searchFilter + "=" + searchText + "&status=I")
                  }
              },
          }
      };
</script>

<style></style>